import {
  Box,
  Button,
  Card,
  Chip,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import Dashboard from "../../organisms/Analytics/Dashboard/Dashboard";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "../../components/svg/DownloadIcon";
import SettingsIcon from "@mui/icons-material/Settings";

interface TrendDetail {
  Total: string;
  Diff: string;
  Trend: string;
}

interface TrendData {
  [key: string]: TrendDetail;
}

interface AnalyticsTemplateProps {
  selectedTab: number;
  setSelectedTab: (tab: number) => void;
  month: string;
  setMonth: (month: string) => void;
  timePeriods: any[];
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  organicRef: React.RefObject<HTMLDivElement>;
  webRef: React.RefObject<HTMLDivElement>;
  aiRef: React.RefObject<HTMLDivElement>;
  ChartData: any[];
  ChartKey: any[];
  trendData: TrendData;
  queryContentGroupsData: any[];
  contentData: any[];
  queriesData: any[];
  queryClustersData: any[];
  screenHeight: any;
  loading: boolean;
  goals: any[];
  ga4Data: any[];
  ga4Date: any[];
  memoizedGACardData: any;
  ga4BarData: any[];
  ga4BarDate: any[];
  sessionSource: any[];
  landingPageContentData: any[];
  pagePath: any[];
  location: string;
  handleChange: any;
  profileData: any;
  interactions: any;
  interActionTrendData: any;
  localPresenceQueries: any[];
  localRef: React.RefObject<HTMLDivElement>;
  keyword: any;
  setKeyword: any;
  handleAddKeyword: any;
  keywords: any;
  handleRemoveKeyword: any;
  newCluster: any;
  clusters: any;
  editCluster: any;
  startNewCluster: any;
  setNewCluster: any;
  newCondition: any;
  setNewCondition: any;
  saveCondition: any;
  saveCluster: any;
  cancelCluster: any;
  removeCluster: any;
  filteredQueries: any;
  newContentGroup: any;
  contentGroups: any;
  editContentGroup: any;
  startNewContentGroup: any;
  setNewContentGroup: any;
  newContentCondition: any;
  setNewContentCondition: any;
  saveContentCondition: any;
  saveContentGroup: any;
  cancelContentGroup: any;
  removeContentGroup: any;
  filteredContentData: any;
  secondTabRef: any;
  funnelData: any;
  aiTrendData: any;
  aiBarData: any;
  aiLineData: any;
  reviewsData: any;
  reviewsRef: React.RefObject<HTMLDivElement>;
  topQueriesCards: any;
  topQueries: any;
  chartReady: any;
}

const AnalyticsTemplate: React.FC<AnalyticsTemplateProps> = ({
  selectedTab,
  setSelectedTab,
  month,
  setMonth,
  timePeriods,
  handleTabChange,
  organicRef,
  webRef,
  aiRef,
  ChartData,
  ChartKey,
  trendData,
  queryContentGroupsData,
  contentData,
  queriesData,
  queryClustersData,
  screenHeight,
  loading,
  goals,
  ga4Data,
  ga4Date,
  memoizedGACardData,
  ga4BarData,
  ga4BarDate,
  sessionSource,
  landingPageContentData,
  pagePath,
  location,
  handleChange,
  profileData,
  interactions,
  interActionTrendData,
  localPresenceQueries,
  localRef,
  keyword,
  setKeyword,
  handleAddKeyword,
  keywords,
  handleRemoveKeyword,
  newCluster,
  clusters,
  editCluster,
  startNewCluster,
  setNewCluster,
  newCondition,
  setNewCondition,
  saveCondition,
  saveCluster,
  cancelCluster,
  removeCluster,
  filteredQueries,
  newContentGroup,
  contentGroups,
  editContentGroup,
  startNewContentGroup,
  setNewContentGroup,
  newContentCondition,
  setNewContentCondition,
  saveContentCondition,
  saveContentGroup,
  cancelContentGroup,
  removeContentGroup,
  filteredContentData,
  secondTabRef,
  funnelData,
  aiTrendData,
  aiBarData,
  aiLineData,
  reviewsData,
  reviewsRef,
  topQueriesCards,
  topQueries,
  chartReady,
}) => {
  return (
    <Box className="dashboardV2">
      <Box className="title-tab-v2">
        <Box className="title-container-v2">
          <Typography
            variant="h4"
            sx={{
              color: "rgba(0, 0, 0, 0.87)",
              fontFeatureSettings: "'liga' off, 'clig' off",
              textAlign: "center",
            }}
          >
            Analytics
          </Typography>
          {false && (
            <Button
              color="primary"
              variant="contained"
              size="large"
              endIcon={<DownloadIcon />}
            >
              Download Report
            </Button>
          )}
        </Box>
        <Box className="tab-container-v2" sx={{ borderBottom: "1px solid #0000000D" }}>
          <Box className="tab-v2">
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Organic" sx={{ textTransform: "none" }} />
              <Tab label="Web" sx={{ textTransform: "none" }} />
              <Tab label="AI Search" sx={{ textTransform: "none" }} />
              {false && (
                <Tab label="Local Search" sx={{ textTransform: "none" }} />
              )}
              {false && <Tab label="Reviews" sx={{ textTransform: "none" }} />}
              {false && <Tab label="Reviews" sx={{ textTransform: "none" }} />}
            </Tabs>
          </Box>
          <Box className="settings-tab-v2" marginBottom={0.5}>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={month}
              defaultValue="3 months"
              onChange={(e) => {
                setMonth(e.target.value);
              }}
              sx={{
                color: "#6e6b6b",
                height: "40px",
                outline: "none",
                background: "#fff",
                border: "none",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
            >
              {timePeriods.map((timePeriod) => (
                <MenuItem key={timePeriod.id} value={timePeriod.value}>
                  {timePeriod.label}
                </MenuItem>
              ))}
            </Select>
            <IconButton>
              <SettingsIcon
                onClick={() => {
                  setSelectedTab(5);
                  secondTabRef.current = true;
                }}
                sx={{ width: "20px", height: "20px" }}
              />
            </IconButton>
          </Box>
        </Box>
      </Box>
      {selectedTab === 0 && (
        <>
          <Dashboard
            organicRef={organicRef}
            webRef={webRef}
            aiRef={aiRef}
            ChartData={ChartData}
            ChartKey={ChartKey}
            trendData={trendData}
            queryContentGroupsData={queryContentGroupsData}
            contentData={contentData}
            queriesData={queriesData}
            queryClustersData={queryClustersData}
            setSelectedTab={setSelectedTab}
            screenHeight={screenHeight}
            loading={loading}
            goals={goals}
            ga4Data={ga4Data}
            ga4Date={ga4Date}
            memoizedGACardData={memoizedGACardData}
            ga4BarData={ga4BarData}
            ga4BarDate={ga4BarDate}
            sessionSource={sessionSource}
            landingPageContentData={landingPageContentData}
            pagePath={pagePath}
            location={location}
            handleChange={handleChange}
            profileData={profileData}
            interactions={interactions}
            interActionTrendData={interActionTrendData}
            localPresenceQueries={localPresenceQueries}
            localRef={localRef}
            funnelData={funnelData}
            aiTrendData={aiTrendData}
            aiBarData={aiBarData}
            aiLineData={aiLineData}
            reviewsData={reviewsData}
            reviewsRef={reviewsRef}
            month={month}
            topQueriesCards={topQueriesCards}
            topQueries={topQueries}
            chartReady={chartReady}
          />
        </>
      )}
      {selectedTab === 5 && (
        <Box>
          <>
            <Card
              sx={{
                padding: 3,
                bgcolor: "#F6F8F8",
                boxShadow: "none !important",
              }}
            >
              <Typography variant="h6" className="customcolor">
                Branded Keywords
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ marginTop: 1 }}
              >
                Add branded keywords that are unique to your brand. There can be
                multiple, the simplest example is the name of your business.
              </Typography>

              {/* Input field and Add Button */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1,
                  marginTop: 2,
                }}
              >
                <TextField
                  variant="outlined"
                  size="small"
                  label="Enter a keyword"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleAddKeyword();
                    }
                  }}
                />
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={(e) => {
                    e.preventDefault();
                    handleAddKeyword();
                  }}
                  disabled={!keyword.trim()}
                  sx={{ fontSize: "14px" }}
                >
                  Add
                </Button>
              </Box>

              {/* Chip list of keywords */}
              <Stack direction="row" spacing={1} sx={{ mt: 2, mb: 2 }}>
                {keywords !== undefined &&
                  keywords.length > 0 &&
                  keywords.map((kw: any) => (
                    <Chip
                      key={kw}
                      label={kw}
                      onDelete={() => handleRemoveKeyword(kw)}
                      deleteIcon={
                        <CancelIcon sx={{ width: "16px", height: "16px" }} />
                      }
                      sx={{
                        fontSize: "13px",
                        minHeight: "24px",
                        height: "24px",
                      }}
                    />
                  ))}
              </Stack>
            </Card>

            <Card
              sx={{
                marginTop: 1,
                padding: 3,
                bgcolor: "#F6F8F8",
                boxShadow: "none !important",
              }}
            >
              <Box sx={{ marginTop: "16px" }}>
                <Typography variant="h6" gutterBottom sx={{ color: "#171D1A" }}>
                  Query Clusters
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Clusters are a collection of related keywords. Grouping allows
                  for more efficient analysis. The simplest example are terms
                  you use to describe your core products and services.
                </Typography>

                {/* Display saved clusters */}
                {!newCluster && (
                  <Box
                    sx={{
                      marginTop: 3,
                      display: "flex",
                      flexWrap: "wrap",
                      rowGap: 2,
                    }}
                  >
                    {clusters !== undefined &&
                      clusters.length > 0 &&
                      clusters.map((cluster: any, index: number) => (
                        <Box
                          key={index}
                          sx={{ width: "252px", cursor: "pointer" }}
                          onClick={() => editCluster(index)}
                        >
                          <Typography
                            variant="subtitle2"
                            fontWeight="500"
                            gutterBottom
                          >
                            {cluster.name}
                          </Typography>
                          {cluster.conditions.map(
                            (cond: any, condIndex: number) => (
                              <Typography
                                key={condIndex}
                                variant="body2"
                                color="text.secondary"
                              >
                                {cond.condition}: {cond.value}
                              </Typography>
                            )
                          )}
                        </Box>
                      ))}
                  </Box>
                )}

                {/* New Cluster Creation */}
                {!newCluster ? (
                  <Button
                    variant="outlined"
                    onClick={startNewCluster}
                    sx={{
                      bgcolor: "#1976d2",
                      color: "#fff",
                      "&:hover": { bgcolor: "#1565c0" },
                      marginTop: 3,
                    }}
                  >
                    New Query Cluster
                  </Button>
                ) : (
                  <Box sx={{ marginTop: 3 }}>
                    <TextField
                      label="Cluster Name"
                      variant="outlined"
                      size="small"
                      sx={{ marginBottom: 2, width: "220px" }}
                      value={newCluster.name}
                      onChange={(e) =>
                        setNewCluster({
                          ...newCluster,
                          name: e.target.value,
                        })
                      }
                    />
                    <Typography
                      variant="subtitle2"
                      sx={{ fontSize: "14px", color: "#171D1A" }}
                    >
                      Conditions
                    </Typography>

                    {/* Display saved conditions for the current new cluster */}
                    {newCluster.conditions.map((cond: any, index: number) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          marginBottom: 1,
                        }}
                      >
                        {/* Condition Select */}
                        <FormControl
                          variant="outlined"
                          size="small"
                          sx={{ width: "296px" }}
                        >
                          <Select
                            value={cond.condition}
                            onChange={(e) => {
                              const updatedConditions = [
                                ...newCluster.conditions,
                              ];
                              updatedConditions[index] = {
                                ...updatedConditions[index],
                                condition: e.target.value as string,
                              };
                              setNewCluster({
                                ...newCluster,
                                conditions: updatedConditions,
                              });
                            }}
                          >
                            <MenuItem value="contains">Contains</MenuItem>
                            <MenuItem value="equals">Equals</MenuItem>
                            <MenuItem value="startsWith">Starts with</MenuItem>
                            <MenuItem value="endsWith">Ends with</MenuItem>
                          </Select>
                        </FormControl>

                        {/* Value Input */}
                        <TextField
                          size="small"
                          label="Value"
                          variant="outlined"
                          fullWidth
                          value={cond.value}
                          onChange={(e) => {
                            const updatedConditions = [
                              ...newCluster.conditions,
                            ];
                            updatedConditions[index] = {
                              ...updatedConditions[index],
                              value: e.target.value,
                            };
                            setNewCluster({
                              ...newCluster,
                              conditions: updatedConditions,
                            });
                          }}
                        />

                        {/* Delete Icon */}
                        <IconButton
                          aria-label="delete"
                          onClick={() => {
                            const updatedConditions =
                              newCluster.conditions.filter(
                                (_: any, i: any) => i !== index
                              );
                            setNewCluster({
                              ...newCluster,
                              conditions: updatedConditions,
                            });
                          }}
                          sx={{
                            color: "#0F4343",
                            width: "24px",
                            height: "24px",
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    ))}

                    {/* New Condition Input */}
                    {newCondition && (
                      <>
                        <Box sx={{ display: "flex", gap: 1, marginTop: 2 }}>
                          <FormControl
                            variant="outlined"
                            size="small"
                            sx={{ width: "296px" }}
                          >
                            <Select
                              value={newCondition.condition}
                              onChange={(e) =>
                                setNewCondition({
                                  ...newCondition,
                                  condition: e.target.value as string,
                                })
                              }
                            >
                              <MenuItem value="contains">Contains</MenuItem>
                              <MenuItem value="equals">Equals</MenuItem>
                              <MenuItem value="startsWith">
                                Starts with
                              </MenuItem>
                              <MenuItem value="endsWith">Ends with</MenuItem>
                            </Select>
                          </FormControl>
                          <TextField
                            size="small"
                            label="Value"
                            variant="outlined"
                            fullWidth
                            value={newCondition.value}
                            onChange={(e) => {
                              setNewCondition({
                                ...newCondition,
                                value: e.target.value,
                              });
                            }}
                          />
                        </Box>
                        <Box sx={{ marginTop: "10px" }}>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={saveCondition}
                          >
                            Add
                          </Button>
                        </Box>
                      </>
                    )}

                    {/* Save or cancel the entire cluster */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        marginTop: 3,
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={saveCluster}
                        sx={{ bgcolor: "#388e3c" }}
                      >
                        Save
                      </Button>
                      <Button variant="outlined" onClick={cancelCluster}>
                        Cancel
                      </Button>
                      <IconButton
                        aria-label="delete"
                        sx={{
                          color: "#0F4343",
                          width: "24px",
                          height: "24px",
                        }}
                        onClick={() => {
                          removeCluster(newCluster?.index);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>

                    <Box sx={{ marginTop: 3 }}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: filteredQueries.length > 0 ? "#388e3c" : "red",
                        }}
                      >
                        {filteredQueries.length === 0
                          ? "There are no matching queries"
                          : `${filteredQueries.length} matching queries`}
                      </Typography>
                      {filteredQueries
                        .slice(0, 20)
                        .map((query: any, index: number) => (
                          <Box sx={{ marginTop: 1 }} key={index}>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "12px" }}
                            >
                              {query}
                            </Typography>
                          </Box>
                        ))}
                      {filteredQueries.length > 20 && (
                        <Box sx={{ marginTop: 1 }}>
                          <Typography
                            sx={{ fontSize: "13px", color: "#0266D1" }}
                          >
                            + {filteredQueries.length - 20} other queries
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>
            </Card>

            <Card
              sx={{
                marginTop: 1,
                padding: 3,
                bgcolor: "#F6F8F8",
                boxShadow: "none !important",
              }}
            >
              <Box>
                <Typography variant="h6" gutterBottom sx={{ color: "171D1A" }}>
                  Content Groups
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ marginBottom: 3 }}
                >
                  These are a collection of related pages. Simplest examples are
                  pages related to blogs, or a similar topic.
                </Typography>

                {/* Display saved content group */}
                {!newContentGroup && (
                  <Box
                    sx={{
                      marginBottom: 3,
                      display: "flex",
                      flexWrap: "wrap",
                      flexDirection: "column",
                      rowGap: 2,
                      justifyContent: "flex-start",
                    }}
                  >
                    {contentGroups !== undefined &&
                      contentGroups.length > 0 &&
                      contentGroups.map((content: any, index: number) => (
                        <Box
                          key={index}
                          sx={{
                            width: "252px",
                          }}
                          onClick={() => editContentGroup(index)}
                        >
                          <Typography
                            variant="subtitle2"
                            fontWeight="500"
                            gutterBottom
                          >
                            {content.name}
                          </Typography>
                          {content.conditions.map(
                            (cond: any, condIndex: number) => (
                              <Typography
                                key={condIndex}
                                variant="body2"
                                color="text.secondary"
                              >
                                {cond.condition}: {cond.value}
                              </Typography>
                            )
                          )}
                        </Box>
                      ))}
                  </Box>
                )}

                {/* New ContentGroup Creation */}
                {!newContentGroup ? (
                  <Button
                    variant="outlined"
                    onClick={startNewContentGroup}
                    sx={{
                      bgcolor: "#1976d2",
                      color: "#fff",
                      "&:hover": { bgcolor: "#1565c0" },
                    }}
                  >
                    New Content Group
                  </Button>
                ) : (
                  <Box>
                    <TextField
                      label="Cluster Name"
                      variant="outlined"
                      size="small"
                      sx={{ marginBottom: 2, width: "220px" }}
                      value={newContentGroup.name}
                      onChange={(e) =>
                        setNewContentGroup({
                          ...newContentGroup,
                          name: e.target.value,
                        })
                      }
                    />

                    {/* Display saved conditions for the current new content group */}
                    {newContentGroup.conditions.map(
                      (cond: any, index: number) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            marginBottom: 1,
                          }}
                        >
                          {/* Dropdown for selecting condition */}
                          <FormControl
                            variant="outlined"
                            size="small"
                            sx={{ width: "250px" }}
                          >
                            <Select
                              value={cond.condition}
                              onChange={(e) => {
                                const updatedConditions = [
                                  ...newContentGroup.conditions,
                                ];
                                updatedConditions[index] = {
                                  ...updatedConditions[index],
                                  condition: e.target.value as string,
                                };
                                setNewContentGroup({
                                  ...newContentGroup,
                                  conditions: updatedConditions,
                                });
                              }}
                            >
                              <MenuItem value="contains">Contains</MenuItem>
                              <MenuItem value="equals">Equals</MenuItem>
                              <MenuItem value="startsWith">
                                Starts with
                              </MenuItem>
                              <MenuItem value="endsWith">Ends with</MenuItem>
                            </Select>
                          </FormControl>

                          {/* Text field for value */}
                          <TextField
                            size="small"
                            label="Value"
                            fullWidth
                            variant="outlined"
                            value={cond.value}
                            onChange={(e) => {
                              const updatedConditions = [
                                ...newContentGroup.conditions,
                              ];
                              updatedConditions[index] = {
                                ...updatedConditions[index],
                                value: e.target.value,
                              };
                              setNewContentGroup({
                                ...newContentGroup,
                                conditions: updatedConditions,
                              });
                            }}
                          />

                          {/* Delete icon */}
                          <IconButton
                            aria-label="delete-condition"
                            sx={{
                              color: "#0F4343",
                              width: "24px",
                              height: "24px",
                            }}
                            onClick={() => {
                              const updatedConditions =
                                newContentGroup.conditions.filter(
                                  (_: any, condIndex: number) =>
                                    condIndex !== index
                                );
                              setNewContentGroup({
                                ...newContentGroup,
                                conditions: updatedConditions,
                              });
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      )
                    )}

                    {/* New Condition Input */}
                    {newContentCondition && (
                      <>
                        <Box sx={{ display: "flex", gap: 1, marginTop: 2 }}>
                          <FormControl
                            variant="outlined"
                            size="small"
                            sx={{ width: "292px" }}
                          >
                            <Select
                              value={newContentCondition.condition}
                              onChange={(e) =>
                                setNewContentCondition({
                                  ...newContentCondition,
                                  condition: e.target.value as string,
                                })
                              }
                            >
                              <MenuItem value="contains">Contains</MenuItem>
                              <MenuItem value="equals">Equals</MenuItem>
                              <MenuItem value="startsWith">
                                Starts with
                              </MenuItem>
                              <MenuItem value="endsWith">Ends with</MenuItem>
                            </Select>
                          </FormControl>
                          <TextField
                            size="small"
                            label="Value"
                            variant="outlined"
                            fullWidth
                            value={newContentCondition.value}
                            onChange={(e) => {
                              setNewContentCondition({
                                ...newContentCondition,
                                value: e.target.value,
                              });
                            }}
                          />
                        </Box>
                        <Box sx={{ marginTop: "10px" }}>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={saveContentCondition}
                          >
                            Add
                          </Button>
                        </Box>
                      </>
                    )}

                    {/* Save or cancel the entire content group */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        marginTop: 3,
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={saveContentGroup}
                        sx={{ bgcolor: "#388e3c" }}
                      >
                        Save
                      </Button>
                      <Button variant="outlined" onClick={cancelContentGroup}>
                        Cancel
                      </Button>
                      <IconButton
                        aria-label="delete"
                        sx={{
                          color: "#0F4343",
                          width: "24px",
                          height: "24px",
                        }}
                      >
                        {!newContentCondition && (
                          <DeleteIcon
                            onClick={() =>
                              removeContentGroup(newContentGroup?.index)
                            }
                          />
                        )}
                      </IconButton>
                    </Box>

                    <Box sx={{ marginTop: 3 }}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color:
                            filteredContentData.length === 0
                              ? "red"
                              : "#171D1A",
                        }}
                      >
                        {filteredContentData.length === 0
                          ? "There are no matching queries"
                          : `${filteredContentData.length} matching queries`}
                      </Typography>
                      {filteredContentData
                        .slice(0, 20)
                        .map((page: any, index: number) => (
                          <Box sx={{ marginTop: 1 }} key={index}>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "12px" }}
                            >
                              {page}
                            </Typography>
                          </Box>
                        ))}
                      {filteredContentData.length > 20 && (
                        <Box sx={{ marginTop: 1 }}>
                          <Typography
                            sx={{ fontSize: "13px", color: "#0266D1" }}
                          >
                            + {filteredContentData.length - 20} other pages
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>
            </Card>
          </>
        </Box>
      )}
    </Box>
  );
};

export default AnalyticsTemplate;
